import API from '../api';
import Endpoints from 'services/api/endpoints';

export const getMotivos = () => {
  return API.get(`${Endpoints.autorizador.searchMotivos}`).then(res => res.data);
};